const e = {
  name: "MexicoCity",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h8.6L12,6l3.4-6H24v1c0,1.3-0.5,2.6-1.5,3.5C21.6,5.5,20.3,6,19,6h-0.1c-0.2,0.7-0.5,1.3-1,1.8
			C17.1,8.6,16.1,9,15,9h-0.9l2.5,5H13v3h1v-2h2v9h-2v-5h-4v5H8v-9h2v2h1v-3H7.4l2.5-5H9C7.9,9,6.9,8.6,6.2,7.8
			C5.7,7.3,5.3,6.7,5.1,6H5C3.7,6,2.4,5.5,1.5,4.5C0.5,3.6,0,2.3,0,1V0z M13.4,12L12,9.2L10.6,12H13.4z M2.2,2
			c0.1,0.4,0.4,0.8,0.7,1.1C3.4,3.7,4.2,4,5,4h2v1c0,0.5,0.2,1,0.6,1.4C8,6.8,8.5,7,9,7h1.3L7.4,2H2.2z M16.6,2l-2.9,5H15
			c0.5,0,1-0.2,1.4-0.6C16.8,6,17,5.5,17,5V4h2c0.8,0,1.6-0.3,2.1-0.9c0.3-0.3,0.6-0.7,0.7-1.1H16.6z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as MexicoCity
};
